export default __webpack_public_path__ + "static/media/vscode_logo.7ad94492.png";